import React from 'react';
import BulkEditor from '../BulkEditor';
import { filterObjectByKey, snakeToCamel } from '../../helpers';
import { HIDDEN_COLUMNS } from '../../constants/grid.constants';

const DataPageAdder = ({
  toCompare,
  meta,
  parent,
  api: { get, post },
  lookups,
}) => {
  const filterColumns = [
    ...HIDDEN_COLUMNS,
    (parent && snakeToCamel(parent.name)),
  ];

  const makeComparable = rows => rows
    .map(row => filterObjectByKey(row, key => !filterColumns.includes(key)));

  return (
    <BulkEditor
      adding
      onAdd={(toAdd, success) => post({
        data: parent && parent.id
          ? { ...toAdd, [parent.name]: parent.id }
          : toAdd,
        successCallback: () => {
          success();
          get();
        },
      }, meta.currentMeta.item_type)}
      meta={meta}
      lookups={lookups}
      toCompare={toCompare && makeComparable(toCompare)}
    />
  );
};

export default DataPageAdder;
